import { Box, Grid } from '@core/component';
import { useContextMediaQuery } from '@core/context';
import { ESize } from '@core/type';
import { FAQCategoriesEntity, FAQCategoriesResponse } from '@core/type/api';

import { CategoryBlock } from './CategoryBlock';

const PHONE_SPACING = 16;
const DEFAULT_SPACING = 48;

enum EColumnsNumber {
  ONE = 1,
  TWO = 2,
  THREE = 3,
}

export const CategoriesBlock = ({ faqCategories }: FAQCategoriesResponse) => {
  const { isPhone, mediaQuery } = useContextMediaQuery();

  const categories = faqCategories?.sort((a, b) => a.position - b.position);

  const columnsNumber =
    mediaQuery === ESize.XS
      ? EColumnsNumber.ONE
      : mediaQuery === ESize.MD
        ? EColumnsNumber.TWO
        : EColumnsNumber.THREE;
  const spacing = isPhone ? PHONE_SPACING : DEFAULT_SPACING;

  const itemsPerColumn = Math.ceil(categories?.length / columnsNumber);
  const columns: FAQCategoriesEntity[][] = [];

  for (let i = 0; i < (columnsNumber as number); i++) {
    const start = i * itemsPerColumn;
    const end = start + itemsPerColumn;
    columns.push(categories.slice(start, end) || []);
  }

  return (
    <Box marginTop={'64px'} marginBottom={isPhone ? '104px' : '140px'}>
      {columns.length > 0 && (
        <Grid spacing={spacing} isContainer>
          {columns.map((categories, index) => (
            <CategoryCards key={index} categories={categories} spacing={spacing} />
          ))}
        </Grid>
      )}
    </Box>
  );
};

const CategoryCards = ({
  categories,
  spacing,
}: {
  categories: FAQCategoriesEntity[];
  spacing: number;
}) => {
  return (
    <Grid xs={12} md={6} lg={4} spacing={spacing}>
      <Box display={'flex'} flexDirection={'column'} gap={spacing}>
        {categories.map((category) => (
          <CategoryBlock {...category} key={category.name} />
        ))}
      </Box>
    </Grid>
  );
};
